<template>
  <div>
    <New :transfer="transfer" />
  </div>
</template>

<script>
import New from '../packingnew/index.vue'
export default {
  name: 'TransferNew',
  components: {
    New
  },
  data() {
    return {
      transfer:true
    }
  },
  mounted(){
    if(process.env.NODE_ENV === "development")this.transfer = false
  },
  methods: {

  }
}
</script>
